import { createBusinessLogger } from '@/utils/logger/businessLogger';

// 意见反馈事件名称常量
export const FEEDBACK_EVENT_NAMES = {
  FEEDBACK_PAGE_LOAD_FAIL: 'feedback_page_load_fail',
};

// 导出类型定义，既可以当常量用也可以当类型用
export type FeedbackEventNames = typeof FEEDBACK_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = [];

// 基础 Business Logger 实例 - 使用泛型约束事件名称
export const feedbackBusinessLogger = createBusinessLogger<FeedbackEventNames>(
  'feedback',
  categoryNames,
);
